import React, {useContext, useEffect, useState} from "react";
import {Spinner} from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler/esm/OutsideClickHandler";
import Dropdown from "react-dropdown";
import {store} from "../../Store/store";

export default function ReasonHistoryDropdownEditor({row, handleOnEdit, reasonsOptions, value, column, onUpdate, setIsRequestInProgress, monitoringService, getConfirmationEnum, getReasonEnum,}) {
    const [isEditing, setIsEditing] = useState(true);
    const stateObj = useContext(store);
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const dropDownDisabled = isRequestInProgress.state && isRequestInProgress.rowId === row.id;
    const leakId = row.id;
    const assigneeField = row.assignee;
    const remarksField = row.remarks;
    const confirmationField = row.confirmation;
    const excludedField = row.excluded;
    const communicationField = row.communication;

    useEffect(() => {
        if (isEditing) {
            handleOnEdit(true);
        }
    }, [isEditing])

    const finalizeEditing = () => {
        setIsEditing(false);
        handleOnEdit(false);
    }
    const options = reasonsOptions.filter((option) => option.value === Number(row.confirmation)).map(val => {
        return ({
            ...val, key: val.id
        });
    });
    if (options[0].value === 0) {
        return "";
    }
    let newValue = value;

    const _onSelect = (reasonValue) => {
        if (!row.reason) {
            row[column.dataField] = 1;
        }
        onUpdate('reasonChanged');
        if (reasonValue.value === 0) return;
        const selectedReason = reasonsOptions.filter((option) => option.value === reasonValue.value && reasonValue.label === option.label);
        newValue = selectedReason[0].id;
        row[column.dataField] = newValue;
        setIsRequestInProgress(true, row.id);
        monitoringService.updateEditableFields(leakId, assigneeField, remarksField, getConfirmationEnum(confirmationField), getReasonEnum(newValue), excludedField, communicationField)
            .then(response => {
                setIsRequestInProgress(false, row.id);
                finalizeEditing();
            }).catch(error => {
            setIsRequestInProgress(false, row.id);
            console.log(error);
        });
    }
    return (reasonsOptions.length <= 0 ? <Spinner animation="border" variant="primary"/> : <OutsideClickHandler
        onOutsideClick={() => {
            finalizeEditing();
            onUpdate(newValue);
        }}
    >
        <Dropdown controlClassName='dropDownControl' menuClassName='menuControl' value={'Select...'} options={options} id={row.id}
                  key={row.id}
                  disabled={dropDownDisabled}
                  onChange={_onSelect}/>
    </OutsideClickHandler>);
}
